import { VariableType } from 'json-to-graphql-query';

import { Club } from '@/interfaces/club';
import { EntityResource } from './entity.resource';
import { FilterArgs, FilterVariables } from './queryVariables/filters/filters';

/**
 * Moduł klubów
 *
 * @export
 * @class ClubResource
 * @extends {EntityResource<Club>}
 */

export class ClubResource extends EntityResource<Club> {
  public getFields = {
    id: true,
    name: true,
    phoneNumber: true,
    email: true,
    www: true,
    terc: true,
    woj: true,
    pow: true,
    gmi: true,
    lat: true,
    lng: true,
    city: true,
    street: true,
    homeNumber: true,
    localNumber: true,
    postalCode: true,
    description: true,
    teams: { name: true }
  };

  public listFields = {
    id: true,
    name: true,
    city: true,
    street: true,
    homeNumber: true,
    localNumber: true,
    postalCode: true,
    description: true,
    teams: {
      sport: {
        id: true,
        name: true
      }
    }
  };

  protected listVariables = FilterVariables;
  protected listArgs = FilterArgs;

  constructor() {
    super({
      entityName: 'club'
    });
  }

  /**
   * Przyznaje uprawnienia menadżera klubu
   *
   * @param {number} profileId
   * @param {number} clubId
   * @returns {Promise<void>}
   * @memberof TeamResource
   */
  public clubAddManagerPermissions(profileId: number, clubId: number): Promise<void> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { profileId: 'Int!', clubId: 'Int!' },
        clubAddManagerPermissions: {
          __args: {
            profileId: new VariableType('profileId'),
            clubId: new VariableType('clubId')
          }
        }
      }
    });
    return this.mutation({ mutation, variables: { profileId, clubId } }, 'clubAddManagerPermissions');
  }
}

export const clubResource = new ClubResource();
